import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

function PrintableModelDetails({ printableTechDetails = {
  units: null,
}, handleDetailChange }) {
  return (
    <div className="row">
      <div className="col-12 col-sm-6 col-md-3 col-xl-2">
        <div className="section-heading--small u-mb10">Units</div>
        <Select
          id="units"
          className="Select-outline"
          placeholder="Choose units"
          options={I18n.translate('publisher.units')}
          onChange={(data) => handleDetailChange('units', data.value)}
          value={printableTechDetails.units}
          searchable={false}
          clearable={false}
        />
      </div>
    </div>
  )
}

PrintableModelDetails.propTypes = {
  handleDetailChange: PropTypes.func.isRequired,
  printableTechDetails: PropTypes.shape({
    units: PropTypes.string,
  }).isRequired,
}

export default PrintableModelDetails
